var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LrsStatement } from "@/cmi5/statements/LrsStatement";
import { LoggingService as logger } from "@/logging/LoggingService";
const COURSE_STATE_KEY = "courseState";
const DEFAULT_COURSE_STATE = {
    completed: false,
    failed: false,
    passed: false,
    score: 0
};
export const CourseStatusStatement = {
    /**
    * Get the course state data if one exists
    *
    * @return {Promise<Response>} The learners course state or the default course state, if no statement exists on LRS.
    */
    get: () => __awaiter(void 0, void 0, void 0, function* () {
        const courseState = yield LrsStatement.get(COURSE_STATE_KEY);
        return Object.assign(Object.assign({}, DEFAULT_COURSE_STATE), courseState);
    }),
    /**
    * Save the course state to the LRS.
    *
    * @param {CourseState} courseState The course state. Includes the raw score.
    * @return {Promise<Response>} The promise returned by the fetch call representing the xAPI request.
    */
    set: (courseState) => __awaiter(void 0, void 0, void 0, function* () {
        const courseStateToSend = Object.assign(Object.assign({}, DEFAULT_COURSE_STATE), { "completed": courseState.completed, "failed": courseState.failed, "passed": courseState.passed, "score": courseState.score });
        logger.debug("Set course state:" + JSON.stringify(courseStateToSend));
        return LrsStatement.set(COURSE_STATE_KEY, courseStateToSend);
    })
};
